import { ConnectedAppsContainer } from './styles'
import ConnectedApp from './ConnectedApp'

import { PartnerShape } from '../../types'

interface ConnectedAppsListProps {
  connectedApps: PartnerShape[]
}

function ConnectedAppsList({ connectedApps }: ConnectedAppsListProps) {
  return (
    <>
      <ConnectedAppsContainer>
        {connectedApps.map((app) => (
          <ConnectedApp key={app.name} connectedApp={app} />
        ))}
      </ConnectedAppsContainer>
    </>
  )
}

export default ConnectedAppsList
